import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidebarItemDefinition } from '../../../../app/common/model/sidebar-item';
import { MenuSection, MenuSectionToString } from '../../../../app/common/model/const/enum';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { LanguageService } from '../../../core/service/language.service';

export type FilteredMenuItem = {
  href: string;
  label: string;
};

@Component({
    selector: 'app-dashboard-new-menu-hogia',
    templateUrl: './dashboard-new-menu-hogia.component.html',
    styleUrls: ['./dashboard-new-menu-hogia.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({ height: '0px', minHeight: '0', transform: 'scaleY(0)', transformOrigin: 'top' })),
            state('expanded', style({ height: '*', transform: 'scaleY(1)', transformOrigin: 'top' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardNewMenuHogiaComponent implements OnInit {
  autoExpandMenu: boolean = true;
  menuActiveState: number = -1;

  filteredMenuItems: FilteredMenuItem[];
  _menuItems: SidebarItemDefinition[];
  _menuSections: { [key in MenuSection]?: SidebarItemDefinition[] };
  additionalMenuItems: SidebarItemDefinition[];

  isSidebar: boolean;
  @Input() close: () => void;

  get menuItems() {
    return this._menuItems;
  }

  get menuSections() {
    return this._menuSections;
  }

  @Input() set menuItems(value: SidebarItemDefinition[]) {
    this._menuItems = value;
    this.additionalMenuItems = [new SidebarItemDefinition('HELP', '/dh/help', 'help-i', null)];
    this._menuSections = value?.reduce((acc, obj) => {
      let section = obj.section;
      if (!acc[section]) {
        acc[section] = [];
      }
      acc[section]?.push(obj);
      return acc;
    }, {});
    this.setupTranslatableLabels();
  }

  @Output() menuItemClick = new EventEmitter<void>();

  _menuFilterInput: string = '';

  constructor(
    private readonly languageService: LanguageService,
    private readonly router: Router,
    private readonly _nativeWindow: NativeWindowService
  ) {}

  ngOnInit(): void {
    this.languageService.onLangChange.subscribe(() => {
      this.setupTranslatableLabels();
    });

    this.isSidebar = !!this.close; // TODO: merge these two into one variable
  }

  handleClose() {
    if (this.isSidebar) {
      this._collapseMobileMenuItems();
      this.close();
    }
  }

  menuLinkHandler(menuItem: SidebarItemDefinition) {
    if (!menuItem.menuDefinition?.length) {
      if (menuItem.href.startsWith('https://')) {
        this._nativeWindow.openTab(menuItem.href);
      } else {
        if (this.isSidebar) this.handleClose();
        this.router.navigate([menuItem.href]);
      }
    } else {
      menuItem.expanded = !menuItem.expanded;
    }
  }

  setupTranslatableLabels() {
    this.filteredMenuItems = [];
    if (!this._menuItems) return;
    for (let item of this._menuItems) {
      if (item.menuDefinition && item.menuDefinition.length) {
        for (let itemChild of item.menuDefinition) {
          itemChild.label = this.languageService.instant(itemChild.caption);
          this.filteredMenuItems.push({ href: itemChild.href, label: this.languageService.instant(itemChild.caption) });
        }
      }
    }
  }

  getSectionName(section: string) {
    return MenuSectionToString(this._getEnumValueFromString(section));
  }

  private _getEnumValueFromString(str: string): MenuSection | undefined {
    const num = parseInt(str, 10);
    if (!isNaN(num) && Object.values(MenuSection).includes(num)) {
      return num as MenuSection;
    }

    return undefined;
  }

  private _collapseMobileMenuItems() {
    this._menuItems?.forEach(item => {
      item.expanded = false;
    });

    this._menuFilterInput = '';
  }
}
